import { LockOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Checkbox, Col, Form, Input, Modal, Row, Select } from 'antd';
import React, { useState } from "react";
import AxiosServices from 'src/Services/axiosServices';

const {Option} = Select;

interface IData {
    Title: string;
    firstName: string;
    lastName: string;
    username: string;
    email: string;
    password: string;
    passwordConfirmation: string;
    acceptTerms: boolean;
}

const RegistrationForm: React.FC = () => {

    const emptyData: IData = {
        Title: '',
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        acceptTerms: false
    }

    const [ modalOpen, setModalOpen ] = useState(false);
    const [ msg, setMsg ] = useState('');
    const [ username, setUsername ] = useState('');

    // const [ secondsToGo, updateSecondsToGo ] = useState(5);
    const [ OkButton, setOkButton ] = useState('OK');

    const onFinish = (values: IData) => {
        // Here, you can perform further validation or submit the form data to the server.
        AxiosServices.RegisterAccount(values)
            .then(async (response) => {
                setUsername(values.username);
                let secondsToGo = 5;
                const timeToGo = secondsToGo;
                setOkButton(`OK (${timeToGo})`);
                setMsg(`Le compte ${values.username} a bien été créé...<br>Un mail à l'adresse<br><b>${values.email}</b><br>a été envoyé pour la validation de votre compte.`);
                // clearTimeout(timer);
                const timer = setInterval(() => {
                    console.log(`setInterval ${secondsToGo}`)
                    secondsToGo -= 1;
                    setOkButton(`OK (${secondsToGo})`);
                }, 1000);
                setTimeout(() => {
                    clearInterval(timer);
                    modalClose();
                    clearTimeout(timer);
                }, timeToGo * 1000);
                setModalOpen(true);
            })
            .catch(err => {
                console.log(err)
                // console.log('Data', err.response.data)
                // const message: any = err.response.data.message;
                // const mergedMessage = (Array.isArray(message)) ? message.map(item => item.msg).join('<br>') : message;
                // Modal.error({
                //     title: 'Des erreurs sont survenues lors de la validation',
                //     content: (<div dangerouslySetInnerHTML={{
                //         __html: mergedMessage
                //     }}/>),
                // });
            });
    };

    const modalClose = () => {
        // console.log('modalClose reset')
        // console.log(`formRef ${formRef}`);
        // console.log(formRef);
        // formRef?.current?.resetFields();
        setModalOpen(false);
        // formRef?.current?.setFieldsValue(emptyData);
    };

    return (
        <>
            <Modal
                title="Création de compte"
                centered
                open={modalOpen}
                onOk={() => modalClose()}
                footer={[
                    <Button key="submit" type="primary" onClick={modalClose}>
                        {OkButton}
                    </Button>
                ]}>
                <h1>Création de compte</h1>
                <h2>{username}</h2>
                <div className={"centered"} dangerouslySetInnerHTML={{__html: msg}}></div>
            </Modal>
            <div className={"centered"}>
                <Card className="contentCard" title="Registration Form">
                    <Form onFinish={onFinish}
                        // ref={formRef}
                          initialValues={emptyData}>
                        <Row gutter={[ 8, 0 ]}>
                            <Col flex={3}>
                                <Form.Item name="Title"
                                           rules={[
                                               {
                                                   required: true,
                                                   message: "Please input your title!"
                                               }
                                           ]}>
                                    <Select placeholder="Civilité">
                                        <Option value="1">Monsieur</Option>
                                        <Option value="2">Madame</Option>
                                        <Option value="3">Autre</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col flex={4}>
                                <Form.Item
                                    name="firstName"
                                    rules={[ {required: true, message: "Please input your first name!"} ]}
                                >
                                    <Input placeholder="First Name"/>
                                </Form.Item>
                            </Col>
                            <Col flex={4}>
                                <Form.Item
                                    name="lastName"
                                    rules={[ {required: true, message: "Please input your last name!"} ]}
                                >
                                    <Input placeholder="Last Name"/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[ 8, 0 ]}>
                            <Col flex={1}>
                                <Form.Item name="username"
                                           rules={[ {required: true, message: "Please input your username!"} ]}>
                                    <Input prefix={<UserOutlined/>} placeholder="Username"/>
                                </Form.Item>
                            </Col>
                            <Col flex={1}>
                                <Form.Item name="email" rules={[
                                    {
                                        type: 'email',
                                        message: 'The input is not a valid email.'
                                    },
                                    {
                                        required: true,
                                        message: "Please input your email!"
                                    }
                                ]}>
                                    <Input prefix={<MailOutlined/>} type="email" placeholder="Email"/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[ 8, 0 ]}>
                            <Col flex={8}></Col>
                            <Col flex={4}>
                                <Form.Item
                                    name="password"
                                    rules={[ {required: true, message: "Please input your password!"} ]}
                                >
                                    <Input.Password prefix={<LockOutlined/>} placeholder="Password"/>
                                </Form.Item>
                            </Col>
                            <Col flex={4}>
                                <Form.Item
                                    name="passwordConfirmation"
                                    dependencies={[ "password" ]}
                                    rules={[
                                        {required: true, message: "Please confirm your password!"},
                                        ({getFieldValue}) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue("password") === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject("The two passwords do not match!");
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password prefix={<LockOutlined/>} placeholder="Password Confirmation"/>
                                </Form.Item>
                            </Col>
                            <Col flex={8}></Col>
                        </Row>
                        <Form.Item name="acceptTerms" valuePropName="checked" initialValue={false}>
                            <Checkbox>
                                I accept the <a href="/TermOfUse.html">Terms and Conditions</a>
                            </Checkbox>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </>
    );
};

export default RegistrationForm;
